import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: 'root'

})
export class ModalConfirmationDeleteAccountService {
  showModal = signal(false);
  
  openModal(): void {
    this.showModal.update(() => true);
  }
  closeModal(): void {
    this.showModal.update(() => false);
  }
}
